import styled from '@emotion/styled'
import { Button, Table } from 'antd'

export const SpanTag = styled.span`
  color: #4a4a68;
  font-size: 13px;
  font-weight: 500;
  &:after {
    content: '|';
    display: inline-block;
    margin: 0 3px;
  }
  &:last-of-type {
    color: #77778e;

    &:after {
      content: none;
      display: none;
    }
  }
  &:first-of-type {
    color: #4a4a68;
  }
`

export const StyledButton = styled(Button)`
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModifiedTable = styled(Table)`
  .ant-table-column-title {
    flex: none;
  }

  .ant-table-column-sorters {
    gap: 8px;
    justify-content: start;
  }
`

export const Back = styled.div`
  grid-area: back/back;

  display: flex;
  align-items: center;
  gap: 18px;

  cursor: pointer;

  svg {
    fill: #4a4a68;
  }

  span {
    color: #4a4a68;
    line-height: 30px;
    font-size: 20px;
    font-weight: 600;
  }
`

export const Section = styled.div(
  ({
    gridArea,
    caption = false,
    hidden = false,
    canCreate = true
  }: {
    gridArea?: string
    caption?: boolean
    hidden?: boolean
    canCreate?: boolean
  }) => `
  ${gridArea && `grid-area: ${gridArea}/${gridArea};`}
  pointer-events: ${canCreate ? 'all' : 'none'};
  
  display: ${hidden ? 'none' : 'flex'};
  flex-flow: column;
  gap: 24px;
  
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  max-width: 752px;

  ${
    caption &&
    `
      gap: 10px;
      height: min-content;
      max-width: 360px;
    `
  }
`
)

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Title = styled.div`
  display: flex;
  flex-flow: column;

  line-height: 1.5;

  strong {
    font-size: 16px;
    font-weight: 600;
  }

  span {
    font-size: 14px;
    font-weight: 400;
  }
`
